import React from "react";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import InfoIcon from "@mui/icons-material/Info";
import {CardContent, Divider} from "@mui/material";
import styles from "./_ams-application-info-card.module.scss";
import {getEmployeeName} from "../../utils/utils";
import {IEmployee} from "../../Interfaces/Admin/IEmployee";
import {hasValue} from "@amsanalytics/react-shared-library";
import {SummaryValueRow} from "../ApplicationSummaryCard/ApplicationSummaryCard";
import {AmsDeskingHistoryType, IAmsDeskingHistory} from "../../Interfaces/Application/IAmsDeskingHistory";

interface AmsApplicationInfoCardProps {
  employees: IEmployee[];
  latestAmsDeskingHistory: IAmsDeskingHistory;
}

export const AmsApplicationInfoCard: React.FC<AmsApplicationInfoCardProps> = (props) => {
  const deskedBy = hasValue(props.latestAmsDeskingHistory.createdBy) 
    ? getEmployeeName(props.employees, props.latestAmsDeskingHistory!.createdBy) 
    : undefined;  
  
  const historyTypeWasDesked = props.latestAmsDeskingHistory.historyType === AmsDeskingHistoryType.Desk;
  const historyTypeWasPosted = props.latestAmsDeskingHistory.historyType === AmsDeskingHistoryType.Post;
  
  const wasDeskedToAms = historyTypeWasDesked && hasValue(props.latestAmsDeskingHistory.amsDealerAppsId);
  const wasPostedToAms = historyTypeWasPosted && hasValue(props.latestAmsDeskingHistory.amsAccountNumber);
  const wasImportedIntoAms = hasValue(props.latestAmsDeskingHistory.amsApplicationNumber);

  const convertBooleanToYesOrNo = (value: boolean): string => {
    return value ? "Yes" : "No";
  }
  
  const loanNumber = hasValue(props.latestAmsDeskingHistory.amsAccountNumber) && hasValue(props.latestAmsDeskingHistory.amsPrimaryCustomerNumber)
    ? `${props.latestAmsDeskingHistory!.amsPrimaryCustomerNumber}-${props.latestAmsDeskingHistory!.amsAccountNumber}`
    : '';
  
  const deskedOrPostedString = historyTypeWasDesked
    ? "Desked"
    : "Posted";
  
  return (
    <Card className={styles.amsApplicationInfoCardContainer}>
      <CardHeader
        avatar={<InfoIcon />}
        title="AMS Application Details"
      />
      <Divider variant="middle" />
      <CardContent>
        <SummaryValueRow 
          {...props}
          title={deskedOrPostedString}
          value={convertBooleanToYesOrNo(wasDeskedToAms || wasPostedToAms)}
        />
        {hasValue(props.latestAmsDeskingHistory.createdDate) &&
        <>
          <SummaryValueRow 
            {...props}
            title={`${deskedOrPostedString} Date`}
            value={new Date(props.latestAmsDeskingHistory!.createdDate).toLocaleDateString([], { hour: '2-digit', minute: '2-digit' })}
          />
          <SummaryValueRow 
            {...props}
            title={`${deskedOrPostedString} By`}
            value={deskedBy}
          />
        </>
        }
        {historyTypeWasDesked && hasValue(props.latestAmsDeskingHistory.amsDealerAppsId) &&
          <SummaryValueRow 
            {...props}
            title={'Dealer Apps ID'}
            value={props.latestAmsDeskingHistory.amsDealerAppsId}
          />
        }
        {historyTypeWasDesked &&
          <SummaryValueRow 
            {...props}
            title={'Imported'}
            value={convertBooleanToYesOrNo(wasImportedIntoAms)}
          />
        }
        {hasValue(props.latestAmsDeskingHistory.amsApplicationNumber) &&
          <SummaryValueRow 
            {...props}
            title={'Application #'}
            value={props.latestAmsDeskingHistory.amsApplicationNumber}
          />
        }
        {hasValue(loanNumber) &&
          <SummaryValueRow 
            {...props}
            title={'Loan #'}
            value={loanNumber}
          />
        }
        {hasValue(props.latestAmsDeskingHistory.amsPrimaryCustomerNumber) &&
          <SummaryValueRow 
            {...props}
            title={'Customer #'}
            value={props.latestAmsDeskingHistory.amsPrimaryCustomerNumber}
          />
        }
        {hasValue(props.latestAmsDeskingHistory.amsCoAppCustomerNumber) &&
          <SummaryValueRow 
            {...props}
            title={'Cobuyer #'}
            value={props.latestAmsDeskingHistory.amsCoAppCustomerNumber}
          />
        }
      </CardContent>
    </Card>
  );
}